/* global tv */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Freewheel = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.slot) {
      var instances = this.slot.getAdInstances()
      if (instances) {
        var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
        if (instances[adnumber] && instances[adnumber].getPlayheadTime) { return instances[adnumber].getPlayheadTime() }
      }
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.slot) {
      var instances = this.slot.getAdInstances()
      if (instances) {
        var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
        if (instances[adnumber] && instances[adnumber].getDuration) { return instances[adnumber].getDuration() }
      }
    }
    return null
  },

  /** Override to return title */
  getTitle: function () {
    try {
      if (this.titles) {
        return this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._adId
      }
    } catch (err) {
      // youbora.Log.debug('Cant get title')
    }
    return 'unknown'
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (this.slot) {
      var instances = this.slot.getAdInstances()
      if (instances) {
        var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
        if (instances[adnumber] && instances[adnumber].getActiveCreativeRendition) {
          var creativeRendition = instances[adnumber].getActiveCreativeRendition()
          if (creativeRendition && creativeRendition.getPrimaryCreativeRenditionAsset) {
            var asset = creativeRendition.getPrimaryCreativeRenditionAsset()
            if (asset && asset.getUrl && asset.getUrl()) { return asset.getUrl() }
          }
          if (creativeRendition && creativeRendition.getWrapperUrl) {
            return creativeRendition.getWrapperUrl()
          }
        }
      }
    }
    return null
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return tv.freewheel.SDK.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Freewheel'
  },

  getPosition: function () {
    return this.position
  },

  getIsVisible: function () {
    if (!this.contentPlayer) {
      for (var key in this.player) {
        var element = this.player[key]
        if (element && element.videoHeight && element.clientHeight) {
          this.contentPlayer = element
          break
        }
      }
    }
    return youbora.Util.calculateAdViewability(this.contentPlayer)
  },

  getAudioEnabled: function () {
    for (var key in this.player) {
      var element = this.player[key]
      if (element && element.adManager && element.adManager._context && element.adManager._context.getAdVolume) {
        return !!element.adManager._context.getAdVolume()
      }
    }
  },

  getGivenAds: function () {
    return this.slot.getAdCount()
  },

  getBreaksTime: function () {
    var slots = this.getSlots()
    if (!slots) return null
    var times = []
    for (var slotindex in slots) {
      var slot = slots[slotindex]
      if (slot.getAdCount() > 0) {
        var ads = slot.getAdInstances()
        for (var adindex in ads) {
          if (ads[adindex]._creativeRenditions[0]._baseUnit === 'video') {
            if (this.plugin.getDuration() && slot.getTimePosition() > this.plugin.getDuration()) {
              times.push(this.plugin.getDuration())
            } else {
              times.push(slot.getTimePosition())
            }
            break
          }
        }
      }
    }
    return times
  },

  getExpectedBreaks: function () {
    var slots = this.getSlots()
    if (!slots) return null
    var pre = 0
    var mid = 0
    var post = 0
    for (var slotindex in slots) {
      var slot = slots[slotindex]
      if (slot.getAdCount() > 0) {
        var containsVideo = false
        var ads = slot.getAdInstances()
        for (var adindex in ads) {
          if (ads[adindex]._creativeRenditions[0]._baseUnit === 'video') {
            containsVideo = true
            break
          }
        }
        if (containsVideo) {
          if (slot.getTimePosition() === 0) {
            pre++
          } else if (slot.getTimePosition() > this.plugin.getAdapter().getDuration() - 1) {
            post++
          } else {
            mid++
          }
        }
      }
    }
    return { pre, mid, post }
  },

  getGivenBreaks: function () {
    var slots = this.getSlots()
    if (!slots) return null
    var breaks = 0
    for (var slotindex in slots) {
      var slot = slots[slotindex]
      if (slot.getAdCount() > 0) {
        var ads = slot.getAdInstances()
        for (var adindex in ads) {
          if (ads[adindex]._creativeRenditions[0]._baseUnit === 'video') {
            breaks++
            break
          }
        }
      }
    }
    return breaks
  },

  getCreativeId: function () {
    if (this.slot) {
      var instances = this.slot.getAdInstances()
      if (instances) {
        var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
        if (instances[adnumber]) { return instances[adnumber]._creativeId }
      }
    }
    return null
  },

  getSlots: function () {
    if (this.player.currentAdContext) {
      return this.player.currentAdContext._adResponse.getTemporalSlots()
    } else {
      for (var key in this.player) {
        var element = this.player[key]
        if (element && element._adResponse && element._adResponse.getTemporalSlots) {
          return element
        }
      }
    }
    return null
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Enable playhead monitor
    this.canRemoveListeners = true
    // References
    this.events = tv.freewheel.SDK
    this.manifestNoResponse = [
      this.events.ERROR_SECURITY,
      this.events.ERROR_TIMEOUT
    ]
    this.manifestEmpty = [
      this.events.ERROR_NO_AD_AVAILABLE,
      this.events.ERROR_VAST_NO_AD
    ]
    this.manifestWrong = [
      this.events.ERROR_VAST_VERSION_NOT_SUPPORTED,
      this.events.ERROR_VAST_WRAPPER_LIMIT_REACH,
      this.events.ERROR_VAST_XML_PARSING,
      this.events.ERROR_PARSE
    ]
    this.ignoredErrors = [
      this.events.ERROR_ADINSTANCE_UNAVAILABLE
    ]
    this.references = []
    this.references[this.events.EVENT_AD] = this.logListener.bind(this)
    this.references[this.events.EVENT_ERROR] = this.errorListener.bind(this)
    this.references[this.events.EVENT_SLOT_STARTED] = this.slotListener.bind(this)
    this.references[this.events.EVENT_SLOT_ENDED] = this.closeListener.bind(this)
    for (var key in this.manifestNoResponse) {
      this.references[key] = this.noResponseManifestListener.bind(this)
    }
    for (var key2 in this.manifestEmpty) {
      this.references[key2] = this.manifestEmptyListener.bind(this)
    }
    for (var key3 in this.manifestWrong) {
      this.references[key3] = this.manifestWrongListener.bind(this)
    }

    for (var key4 in this.references) {
      this.player.currentAdContext.addEventListener(key4, this.references[key4])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.currentAdContext.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  noResponseManifestListener: function (e) {
    this.fireManifest(youbora.Constants.ManifestError.NO_RESPONSE, 'No response')
  },

  manifestEmptyListener: function (e) {
    this.fireManifest(youbora.Constants.ManifestError.EMPTY, 'Empty manifest')
  },

  manifestWrongListener: function (e) {
    this.fireManifest(youbora.Constants.ManifestError.WRONG, 'Wrong manifest format')
  },

  logListener: function (e) {
    youbora.Log.debug(e.subType)
    if (e.errorCode || e.errorInfo || e.errorModule) {
      this.errorListener(e)
      return
    }
    switch (e.subType) {
      case this.events.EVENT_AD_PAUSE:
        this.pauseListener(e)
        break
      case this.events.EVENT_AD_RESUME:
        this.resumeListener(e)
        break
      case this.events.EVENT_AD_IMPRESSION_END:
        this.endedListener(e)
        break
      case this.events.EVENT_AD_INITIATED:
        this.playListener(e)
        break
      case this.events.EVENT_AD_IMPRESSION:
        this.playingListener(e)
        break
      case this.events.EVENT_AD_SKIPPED:
        this.skipListener(e)
        break
      case this.events.EVENT_SLOT_STARTED:
        this.slotListener(e)
        break
      case this.events.EVENT_AD_CLOSE:
      case this.events.EVENT_SLOT_ENDED:
        this.closeListener(e)
        break
      case this.events.EVENT_AD_CLICK:
        this.clickListener(e)
        break
      case this.events.EVENT_AD_FIRST_QUARTILE:
        this.fireQuartile(1)
        break
      case this.events.EVENT_AD_MIDPOINT:
        this.fireQuartile(2)
        break
      case this.events.EVENT_AD_THIRD_QUARTILE:
        this.fireQuartile(3)
        break
    }
  },

  slotListener: function (e) {
    this.slot = e.slot
    var position = e.slot.getTimePositionClass()
    this.disable = false
    if (position === 'POSTROLL') {
      this.position = youbora.Constants.AdPosition.Postroll
    } else if (position === 'MIDROLL') {
      this.position = youbora.Constants.AdPosition.Midroll
    } else if (position === 'PREROLL') {
      this.position = youbora.Constants.AdPosition.Preroll
      if (this.plugin.getAdapter() && this.plugin.getAdapter().flags.isJoined) {
        this.position = youbora.Constants.AdPosition.Midroll
      }
    } else {
      this.disable = true
    }
    if (!this.disable) {
      this.titles = e.slot.getAdInstances()
      if (this.plugin.getAdapter() && this.canRemoveListeners) {
        this.canRemoveListeners = false
        this.plugin.getAdapter().unregisterListeners()
        this.plugin.getAdapter().firePause()
      }
      this.plugin.fireInit()
      this.fireInit()
    }
  },
  playListener: function (e) {
    if (!this.disable) { this.fireStart() }
  },
  playingListener: function (e) {
    if (!this.disable) {
      this.fireStart()
      this.fireJoin()
      this.fireResume()
    }
  },
  pauseListener: function (e) {
    this.firePause()
  },
  resumeListener: function (e) {
    this.playListener()
    this.fireResume()
  },
  endedListener: function (e) {
    this.fireStop()
  },
  skipListener: function (e) {
    this.fireSkip()
  },
  clickListener: function (e) {
    var url = e.adInstance.getEventCallbackUrls(tv.freewheel.SDK.EVENT_AD_CLICK, tv.freewheel.SDK.EVENT_TYPE_CLICK)[0]
    var now = new Date().getTime()
    if (this.lastUrl === url && now < ((this.lastTime || 0) + 2000)) {
      return
    }
    this.lastUrl = url
    this.lastTime = now
    this.fireClick(url)
  },
  closeListener: function (e) {
    this.register()
    if (this.position === youbora.Constants.AdPosition.Postroll && !this.disable) {
      this.plugin.fireStop()
    }
  },
  errorListener: function (e) {
    this.fireError(e.errorCode || e.subType, e.errorInfo)
    this.fireStop()
    this.register()
  },

  register: function (e) {
    if (this.plugin.getAdapter() && !this.canRemoveListeners) {
      this.plugin.getAdapter().registerListeners()
      this.plugin.getAdapter().fireResume()
      this.canRemoveListeners = true
    }
  },

  changeVideo: function (e) {
    if (this.flags.isStarted || this.flags.isInited) {
      this.fireStop()
      this.plugin.fireStop()
      this.register()
    }
  }
})

module.exports = youbora.adapters.Freewheel
